import React from 'react';
import { Button, CircularProgress, Box, ButtonProps } from '@mui/material';
import useGlobalStore from '../stores/GlobalStore';
import '../style/Components.css';

interface ButtonBoxProps extends ButtonProps {
    text: string;
    onClick: (...args: any[]) => void;
    sx?: object;
    variant?: ButtonProps['variant'];
    icon?: React.ReactNode;
    isError?: boolean;
}

const ButtonBox: React.FC<ButtonBoxProps> = ({
    text,
    onClick,
    variant = "contained",
    icon,
    isError = false, // 預設為 false
    ...props
}) => {
    const { loading } = useGlobalStore();

    const buttonColorStyles = isError
        ? { // 如果是 error 狀態，設置紅色風格
            ...(variant === 'contained' && {
                backgroundColor: 'red', // 自定義錯誤紅色
                color: 'white',
            }),
            ...(variant === 'outlined' && {
                borderColor: 'red',
                color: 'red',
            }),
        }
        : { // 如果不是 error 狀態，使用預設藍色風格
            ...(variant === 'contained' && {
                backgroundColor: 'var(--primary-dark-blue)',
                color: 'white',
            }),
            ...(variant === 'outlined' && {
                borderColor: 'var(--primary-dark-blue)',
                color: 'var(--primary-dark-blue)',
            }),
        };

    return (
        <Button
            variant={variant}
            sx={{
                ...buttonColorStyles, // 動態應用顏色樣式
            }}
            onClick={onClick}
            disabled={loading}
            {...props}
        >
            {loading ? (
                <Box className='flex-box'>
                    <CircularProgress size={24} className={`circularProgress ${isError ? 'circularProgressError' : 'circularProgressNormal'}`} />
                    {text}
                </Box>
            ) : (
                <>
                    {icon}
                    {text}
                </>
            )}
        </Button>
    );
};

export default ButtonBox;
